import React from 'react';
import './Loader.scss'

export default function Loader({ isVisible = false, nonBlocking = false }) {
    return (
      <div className={`loader-overlay ${isVisible ? "visible" : ""} ${nonBlocking ? "non-blocking" : ""}`}>
        <div className="spinner" />
      </div>
    );
  }
  